export enum carType {
  USED = "USED",
  NEW = "NEW"
}